export const TIME_SLOTS = [
  {
    label: '12:00 AM',
    value: '0'
  },
  {
    label: '1:00 AM',
    value: '1'
  },
  {
    label: '2:00 AM',
    value: '2'
  },
  {
    label: '3:00 AM',
    value: '3'
  },
  {
    label: '4:00 AM',
    value: '4'
  },
  {
    label: '5:00 AM',
    value: '5'
  },
  {
    label: '6:00 AM',
    value: '6'
  },
  {
    label: '7:00 AM',
    value: '7'
  },
  {
    label: '8:00 AM',
    value: '8'
  },
  {
    label: '9:00 AM',
    value: '9'
  },
  {
    label: '10:00 AM',
    value: '10'
  },
  {
    label: '11:00 AM',
    value: '11'
  },
  {
    label: '12:00 PM',
    value: '12'
  },
  {
    label: '1:00 PM',
    value: '13'
  },
  {
    label: '2:00 PM',
    value: '14'
  },
  {
    label: '3:00 PM',
    value: '15'
  },
  {
    label: '4:00 PM',
    value: '16'
  },
  {
    label: '5:00 PM',
    value: '17'
  },
  {
    label: '6:00 PM',
    value: '18'
  },
  {
    label: '7:00 PM',
    value: '19'
  },
  {
    label: '8:00 PM',
    value: '20'
  },
  {
    label: '9:00 PM',
    value: '21'
  },
  {
    label: '10:00 PM',
    value: '22'
  },
  {
    label: '11:00 PM',
    value: '23'
  }
]

export const TIME_ZONES = [
  {
    label: '(GMT-12:00) International Date Line West',
    value: '-12'
  },
  {
    label: '(GMT-11:00) Midway Island, Samoa',
    value: '-11'
  },
  {
    label: '(GMT-10:00) Hawaii',
    value: '-10'
  },
  {
    label: '(GMT-09:00) Alaska',
    value: '-9'
  },
  {
    label: '(GMT-08:00) Pacific Time (US & Canada)',
    value: '-8'
  },
  {
    label: '(GMT-07:00) Mountain Time (US & Canada)',
    value: '-7'
  },
  {
    label: '(GMT-06:00) Central Time (US & Canada)',
    value: '-6'
  },
  {
    label: '(GMT-05:00) Eastern Time (US & Canada)',
    value: '-5'
  },
  {
    label: '(GMT-04:00) Atlantic Time (Canada)',
    value: '-4'
  },
  {
    label: '(GMT-03:30) Newfoundland',
    value: '-3:30'
  },
  {
    label: '(GMT-03:00) Greenland, Buenos Aires, Georgetown',
    value: '-3'
  },
  {
    label: '(GMT-02:00) Mid-Atlantic',
    value: '-2'
  },
  {
    label: '(GMT-01:00) Cape Verde Is.',
    value: '-1'
  },
  {
    label: '(GMT+00:00) Greenwich Mean Time : Dublin, Edinburgh, Lisbon, London',
    value: '0'
  },
  {
    label: '(GMT+01:00) Amsterdam, Berlin, Bern, Rome, Stockholm, Vienna',
    value: '1'
  },
  {
    label: '(GMT+02:00) Athens, Bucharest, Istanbul',
    value: '2'
  },
  {
    label: '(GMT+03:00) Kuwait, Riyadh, Baghdad',
    value: '3'
  },
  {
    label: '(GMT+03:30) Tehran',
    value: '3.5'
  },
  {
    label: '(GMT+04:00) Abu Dhabi, Muscat',
    value: '4'
  },
  {
    label: '(GMT+04:30) Kabul',
    value: '4.5'
  },
  {
    label: '(GMT+05:00) Islamabad, Karachi, Tashkent',
    value: '5'
  },
  {
    label: '(GMT+05:30) Chennai, Kolkata, Mumbai, New Delhi',
    value: '5.5'
  },
  {
    label: '(GMT+06:00) Almaty, Novosibirsk',
    value: '6'
  },
  {
    label: '(GMT+06:30) Yangon (Rangoon)',
    value: '6.5'
  },
  {
    label: '(GMT+07:00) Bangkok, Hanoi, Jakarta',
    value: '7'
  },
  {
    label: '(GMT+08:00) Beijing, Hong Kong, Kuala Lumpur, Perth',
    value: '8'
  },
  {
    label: '(GMT+09:00) Seoul',
    value: '9'
  },
  {
    label: '(GMT+09:30) Adelaide, Darwin',
    value: '9.5'
  },
  {
    label: '(GMT+10:00) Canberra, Melbourne, Sydney',
    value: '10'
  },
  {
    label: '(GMT+11:00) Magadan, Solomon Is., New Caledonia',
    value: '11'
  },
  {
    label: '(GMT+12:00) Auckland, Wellington',
    value: '12'
  }
]

export const FREQUENCY = [
  { label: 'Hourly', value: 'HOURLY' },
  { label: 'Daily', value: 'DAILY' },
  { label: 'Weekly', value: 'WEEKLY' },
  { label: 'Monthly', value: 'MONTHLY' },
  { label: 'Yearly', value: 'YEARLY' },
]

export const WEEKDAYS = [
  { label: 'Sun', value: 'SUNDAY' },
  { label: 'Mon', value: 'MONDAY' },
  { label: 'Tues', value: 'TUESDAY' },
  { label: 'Wed', value: 'WEDNESDAY' },
  { label: 'Thur', value: 'THURSDAY' },
  { label: 'Fri', value: 'FRIDAY' },
  { label: 'Sat', value: 'SATURDAY' }
]

export const REPORT_LEVEL = [
  {
    label: 'Report',
    value: 'REPORT'
  },
  {
    label: 'Summary',
    value: 'SUMMARY'
  }
]
